var SearchPageEnum = /* @__PURE__ */ ((SearchPageEnum2) => {
  SearchPageEnum2["SEARCH_PAGE_TITLE"] = "search-page--title";
  SearchPageEnum2["SEARCH_PAGE_SEE_MORE"] = "search-page--see-more";
  SearchPageEnum2["SEARCH_PAGE_TELEMED_TITLE"] = "search-page--telemed-title";
  SearchPageEnum2["SEARCH_PAGE_TELEMED_SEE_MORE"] = "search-page--telemed-see-more";
  SearchPageEnum2["SEARCH_PAGE_EMPTY_STATE"] = "empty-state-section--search-schedule-empty-state";
  SearchPageEnum2["SEARCH_SECTION"] = "search-section";
  SearchPageEnum2["SEARCH_PAGE_SUGGESTIONS_SECTION"] = "search-page--suggestions-section";
  SearchPageEnum2["SEARCH_PAGE_SUGGESTION_TELEHEALTH_CTA"] = "search-page--suggestion-telehealth-cta";
  SearchPageEnum2["SEARCH_PAGE_SUGGESTION_NEAR_CITY_CTA"] = "search-page--suggestion-near-city-cta";
  SearchPageEnum2["SEARCH_PAGE_SUGGESTION_CITY_BRANCH_CARD"] = "search-page--suggestion-city-branch-card";
  SearchPageEnum2["SEARCH_PAGE_SUGGESTION_CITY_BRANCH_PROFILE"] = "search-page--suggestion-city-branch-profile";
  SearchPageEnum2["SEARCH_PAGE_SUGGESTION_CITY_BRANCH_WHATSAPP"] = "search-page--suggestion-city-branch-whatsapp";
  SearchPageEnum2["SEARCH_PAGE_SUGGESTION_CITY_BRANCH_VIEW"] = "search-page--suggestion-city-branch-view";
  SearchPageEnum2["SEARCH_PAGE_SUGGESTION_CITY_BRANCH_MAP"] = "search-page--suggestion-city-branch-map";
  SearchPageEnum2["SEARCH_PAGE_SUGGESTION_CITY_BRANCH_CTA"] = "search-page--suggestion-city-branch-cta";
  SearchPageEnum2["SEARCH_HEADER"] = "search-header";
  SearchPageEnum2["SEARCH_HEADER_LOADING"] = "search-header-loading";
  SearchPageEnum2["SEARCH_HEADER_PILL_ROW"] = "search-header--pill-row";
  SearchPageEnum2["SEARCH_SCHEDULES"] = "search-schedules";
  SearchPageEnum2["SEARCH_CARD_LOADING"] = "search-card-loading";
  SearchPageEnum2["SEARCH_NOT_FOUND"] = "search-not-found";
  SearchPageEnum2["SEARCH_ERROR"] = "search-error";
  return SearchPageEnum2;
})(SearchPageEnum || {});
export {
  SearchPageEnum
};
